import { State } from '@ispm-client/modules/bpmn-modeler/store/state';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectBpmnModelerState } from '@ispm-client/modules/bpmn-modeler/store/selectors/bpmn-modeler-state.selector';
import { SaveParams } from '@ispm-client/modules/bpmn-modeler/models/save-params';

/**
 * Created By Elia Rohana on 2/12/19
 */
const getSaveParams = (state: State): SaveParams => state.saveParams;

export const selectSaveParams: MemoizedSelector<object, SaveParams> = createSelector(selectBpmnModelerState, getSaveParams);
